import { useCallback, useState } from "react";
import { getLogs } from "../../../components/logs/functions";
import { defaultLogDateRange } from "../../../components/logs/dateDefaults";
import { useStableSearch } from "../../hooks/useStableSearch";

const defaultDates = defaultLogDateRange(30);

export const DEFAULT_LOG_FILTERS = {
  q: "",
  target: "",
  from: defaultDates.from,
  to: defaultDates.to,
};

function hasRequiredDates(filters) {
  return Boolean(filters.from?.trim() && filters.to?.trim());
}

export function useLogsSearch(user) {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [filters, setFilters] = useState(DEFAULT_LOG_FILTERS);

  const runSearch = useCallback(async ({ token, filters: activeFilters, isCurrent }) => {
    if (!hasRequiredDates(activeFilters)) {
      return;
    }

    setLoading(true);
    setError(null);

    const { target, q, from, to } = activeFilters;
    const data = await getLogs(token, target, undefined, undefined, from, to, q);

    if (!isCurrent()) {
      return;
    }

    if (data?.type === "error") {
      setError(data);
      setLogs([]);
    } else if (data?.type === "success") {
      setLogs(Array.isArray(data.data) ? data.data : []);
    } else {
      setLogs([]);
    }

    setLoading(false);
  }, []);

  const search = useStableSearch(user?.token, filters, runSearch);
  const refresh = useCallback(() => search(), [search]);

  return { logs, loading, error, filters, setFilters, search, refresh };
}
